/* eslint-disable */
import React, { useState } from 'react';
import useAuth from 'hooks/useAuth';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { ListingActions } from 'store/slices/listings';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';

export default function SyncDataWithAbor({ data, propertyId, listingId }) {
    const { role } = useAuth();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const { syncListingWithAbor } = ListingActions;

    const handleSyncListingWithAbor = async () => {
        setLoading(true);
        try {
            const data = await dispatch(syncListingWithAbor(propertyId));
            if (data?.payload?.success) {
                toast.success('Syncing is in Progress, refresh again in some minutes');
            } else {
                throw new Error('Error from backend');
            }
        } catch (error) {
            console.log(error);
            toast.error('Some error occured in sync the data with Abot');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 4 }}>
                <Typography variant="h4" color="textSecondary">
                    Sync History
                </Typography>
                <Box sx={{ display: 'flex', flexDirection:'column', alignItems: 'start', gap: 1 }}>
                <LoadingButton
                    loading={loading}
                    autoFocus
                    onClick={() => {
                        handleSyncListingWithAbor();
                    }}
                    disabled={data?.length > 0}
                    variant="contained"
                >
                    Sync Latest Data with Abor
                </LoadingButton>
                <Typography variant="h6" color="red">
                    Data Syncing May take upto 5-10 minutes
                </Typography>
                </Box>
            </Box>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <strong>User Detail</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Status</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Finished At</strong>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((entry, index) => (
                            <TableRow key={`${entry?.id}-${index}`}>
                                <TableCell>
                                    <Box>
                                        <Typography variant="body1" fontWeight="bold" style={{ textTransform: 'capitalize' }}>
                                            {entry?.user?.firstName + ' ' + (entry?.user?.lastName ?? '')}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            {entry?.user?.roleName}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            {entry?.user?.email}
                                        </Typography>
                                    </Box>
                                </TableCell>
                                <TableCell style={{ textTransform: 'capitalize' }}>{entry?.status}</TableCell>

                                <TableCell>
                                    {entry?.finishedAt
                                        ? new Date(entry?.finishedAt).toLocaleString('en-US', {
                                              year: 'numeric',
                                              month: 'short',
                                              day: 'numeric',
                                              hour: '2-digit',
                                              minute: '2-digit'
                                          })
                                        : 'Not Yet Finished'}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {data.length <= 0 && (
                <Box sx={{ width: '100%', minHeight: '5rem', textAlign: 'center', verticalAlign: 'center' }}>
                    <Typography variant="h4" color="textSecondary" sx={{ mt: 4 }}>
                        No data available
                    </Typography>
                </Box>
            )}
        </>
    );
}
